import type React from 'react'
import { Texto, addCommasToNumber } from '@gravitate-js/excalibrr'
import { useFormatter } from '@api/useFormatter'

interface ProductTotalProps {
  value: number
}

export const ProductTotal: React.FC<ProductTotalProps> = ({ value }) => {
  const { formatCurrency } = useFormatter()
  const currencySymbol = formatCurrency(null, true)

  return (
    <Texto style={{ width: '100%', textAlign: 'right' }}>
      {currencySymbol}
      {addCommasToNumber(value || 0, 2)}
    </Texto>
  )
}
